const Editor = (($) => {

    const NAME = 'editor';
    const DATA_KEY = `bs.${NAME}`;
    const JQUERY_NO_CONFLICT = $.fn[NAME];

    const Default = {
        focus: false,
        buttons: {},
        tableClassName: 'table table-xxs table-bordered',
        height: null,
        toolbar: [
            ['style', ['style']],
            ['font', ['bold', 'underline', 'clear']],
            ['fontname', ['fontname']],
            ['color', ['color']],
            ['para', ['ul', 'ol', 'paragraph']],
            ['insert', ['hr', 'table', 'link']],
            ['view', ['fullscreen', 'codeview', 'help']]
        ]
        
    };
    const Selector = {
        CLASS_NAME: `.js-${NAME}`
    }

    class Editor {
        constructor(element, config) {
            this._config = config;
            this._element = element;
            this._$element = $(this._element);
            if (this._$element.prop('readonly') || this._$element.prop('disabled')) {
                this._$element.summernote('disable');
                this._$element.next().children('.note-toolbar').addClass('hidden');
            }
            
            this._$element.on('summernote.blur', (content) => this._blur(content));

        }

        _blur(content) {
            const $element = $(this._element),
                validate = $element.closest('form').validate();

            if ($element.summernote('isEmpty')) {
                $element.val('');
            }
            validate.element($element);
        }

        dispose() {
            $.removeData(this._element, DATA_KEY);
            this._config = null;
            this._element = null;
        }
        
        static _jQueryInterface() {
            return this.each(function () {
                const $this = $(this);
                let data = $this.data(DATA_KEY);
                const config = $.extend({}, Default, $this.data());
                if (!data) {
                    data = new Editor(this, config);
                    $this.data(DATA_KEY, data).summernote(config);
                }
            });
        }
    }

    $(() => Editor._jQueryInterface.call($(Selector.CLASS_NAME)));
    $(document).ajaxStop(() => Editor._jQueryInterface.call($(Selector.CLASS_NAME)));

    $.fn[NAME] = Editor._jQueryInterface;
    $.fn[NAME].Constructor = Editor;
    $.fn[NAME].noConflict = function () {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return Editor._jQueryInterface;
    }

    return Editor;
})(jQuery);